import { canonizeNpmId, toCanonicalClassName } from '@bit/bit.javascript.default-generator.canonize';
export var mainFile = 'app.module.ts';
export function makeAngularTemplate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      npmId = _ref.npmId;

  return {
    files: {
      'app.component.html': html,
      'app.component.scss': css,
      'app.component.ts': ts,
      'app.module.ts': genAppModule({
        npmId: npmId
      })
    },
    mainFile: mainFile
  };
}

function genAppModule(_ref2) {
  var npmId = _ref2.npmId;
  var moduleName = "".concat(toCanonicalClassName(npmId), "Module");
  var moduleId = canonizeNpmId(npmId);
  return "import { BrowserModule } from '@angular/platform-browser';\nimport { NgModule } from '@angular/core';\n\nimport { AppComponent } from './app.component';\n".concat(npmId ? "import { ".concat(moduleName, " } from '").concat(moduleId, "';") : '', "\n\n@NgModule({\n\tdeclarations: [\n\t\tAppComponent,\n\t],\n\timports: [\n\t\tBrowserModule,\n\t\t").concat(moduleName ? moduleName : '', "\n\t],\n\tproviders: [],\n\tbootstrap: [AppComponent]\n})\nexport class AppModule { }");
}

var html = "<!--The content below is only a placeholder and can be replaced.-->\n<div style=\"text-align:center\">\n\t<img width=\"46\" alt=\"Angular Logo\" style=\"margin-bottom: 29px\"\n\t\tsrc=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg==\"\n\t>\n\t<div style=\"font-size: 17px; color: #414141; font-family: sans-serif; line-height: 1.61;\">\n\t\tStart editing <b><i>app.component.html</i></b> to see your example rendered.\n\t\t<br/>\n\t\tClick save when ready.\n\t</div>\n</div>\n";
var ts = "import { Component } from '@angular/core';\n\n@Component({\n\tselector: 'app-root',\n\ttemplateUrl: './app.component.html',\n\tstyleUrls: ['./app.component.scss']\n})\nexport class AppComponent {\n\ttitle = 'capsule';\n}\n";
var css = "";